import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/auth.css';

const RegisterPage = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    username: '',
    password: '',
    streetAddress: '',
    city: '',
    postalCode: '',
    country: '',
    phoneNumber: ''
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch( `${API_BASE_URL}/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
          address: {
            streetAddress: formData.streetAddress,
            city: formData.city,
            postalCode: formData.postalCode,
            country: formData.country
          }
        })
      });

      const data = await response.json().catch(() => ({})); // Handle empty responses

      if (!response.ok) {
        throw new Error(data.error || 'Registration failed');
      }

      alert('Uspešna registracija! Molimo vas ulogujte se.');
      navigate('/login');
    } catch (error) {
      console.error('Registration error:', error);
      alert(error.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h1>Registracija</h1>
        <form onSubmit={handleRegister}>
          <input
            name="firstName"
            type="text"
            placeholder="Ime"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
          <input
            name="lastName"
            type="text"
            placeholder="Prezime"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
          <input
            name="email"
            type="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            name="username"
            type="text"
            placeholder="Korisničko ime"
            value={formData.username}
            onChange={handleChange}
            required
          />
          <input
            name="password"
            type="password"
            placeholder="Šifra"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <input
            name="streetAddress"
            type="text"
            placeholder="Adresa"
            value={formData.streetAddress}
            onChange={handleChange}
            required
          />
          <input
            name="city"
            type="text"
            placeholder="Grad"
            value={formData.city}
            onChange={handleChange}
            required
          />
          <input
            name="postalCode"
            type="text"
            placeholder="Poštanski broj"
            value={formData.postalCode}
            onChange={handleChange}
            required
          />
          <input
            name="country"
            type="text"
            placeholder="Zemlja"
            value={formData.country}
            onChange={handleChange}
            required
          />
          <input
            name="phoneNumber"
            type="text"
            placeholder="Broj telefona"
            value={formData.phoneNumber}
            onChange={handleChange}
            required
          />
          <button type="submit" disabled={loading}>
            {loading ? 'Registrovanje...' : 'Registruj se'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default RegisterPage;